// Reset the query on each page load and reset it with current query.  setObject overwrites all the values.
export default ({ duck }) => (ctx) => {
    ctx.batchDispatch.createActions(({ query }) => [
        duck.creators.setObject(query),
    ]);
};
